import BrowserUtils from "./browser";


// TODO： IE不支持 includes babel打包无效
if(BrowserUtils.isIE()) {
    String.prototype.includes = function(value){
        return this.indexOf(value) > -1;
    };
    Array.prototype.includes = function(value) {
        return this.indexOf(value) > -1;
    };
}